import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import { LoadableImage } from '../../../components/LoadableImage/LoadableImage';
import styles from './onePost.module.scss'
import lang from '../../../translate/en_US'
import { getPrevUrlForPostingPhoto } from '../../../helpers/functions';
import endpoints from '../../../api/endpoints';
import { AlertModel } from '../../../components/Alert/AlertModel';
import { DangerAlert } from '../../../components/DangerAlert/DangerAlert';
import { Spinner } from 'react-bootstrap';

export const OnePost = ({ post, categories, deleteCallback }) => {
    console.log(post);

    const [withoutImage, setWithoutImage] = useState(false)
    const [errorImage, setErrorImage] = useState(false)
    const [category, setCategory] = useState('...')
    const [subcategory, setSubcategory] = useState('...')
    const [isDeleteAlertVisible, setIsDeleteAlertVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const todayDate = new Date()
    const expiredDate = new Date()
    expiredDate.setDate(todayDate.getDate() - process.env.REACT_APP_EXPIRED_AFTER )
    const postDate = post.activatedDate ? new Date(post.activatedDate) : null

    console.log('post date', postDate);
    console.log('exp date', expiredDate.getDate());

    useEffect(() => {
        // set "no photo" pic for listing without photos
        if (post.photos && Array.isArray(post.photos) && post.photos.length < 1) {
            setWithoutImage(true)
            setErrorImage(false)
        }

        // set "error photo" pic for listing which photos not found
        if (post.photos && Array.isArray(post.photos) && post.photos.length > 0) {
            setWithoutImage(false)
            setErrorImage(false)
            var http = new XMLHttpRequest()
            http.open('HEAD', post.photos[0], false)
            http.send();
            if (http.status === 404) setErrorImage(true)
        }

    }, [post])

    useEffect(() => {
        if (post.category && categories && Array.isArray(categories)) {
            const c = categories.find(oneCat => oneCat.slug === post.category)
            if (c) {
                setCategory(c.title)
                const sc = c.subcategories.find(oneSubCat => oneSubCat.slug === post.subcategory)
                if (sc) setSubcategory(sc.title)
            }

        }
    }, [categories, post])

    const unlikeHandler = async (e) => {
        setIsLoading(true)
        setIsDeleteAlertVisible(false)
        try {
            const answer = await endpoints.unlikePosting({posting: post._id})
            if (answer && answer.data && answer.data === 'SUCCESS') { 
                setIsLoading(false)
                deleteCallback(true)
            } else {
                AlertModel.add('Can\'t unlike posting', 'alert-danger')
                setIsLoading(false)
            }
        } catch (error) {
            console.log('error while trying unlike posting', error);
            setIsLoading(false)
        }
    }

    return (
        <div className={styles.onePostWrapper} >
            <div className={styles.onePost}>

                <div className={styles.leftSide} onClick={(e) => {window.open(process.env.REACT_APP_SITE_ADDR + '/posting/' + post._id, '_blank').focus()} }>
                    { (!withoutImage && !errorImage) && 
                        <LoadableImage className={styles.image} src={getPrevUrlForPostingPhoto(post.photos[0])} width={60} height={60}>
                            <div className={styles.placeholder}><i className="bi bi-arrow-repeat"></i></div>
                        </LoadableImage>
                    }
                    { (withoutImage === true) && <div className={styles.tempImg}><div className={styles.placeholder}><i className="bi bi-image"></i></div></div> }
                    { (errorImage) && <div className={styles.tempImg}><div className={styles.placeholder}><i className="bi bi-exclamation-diamond"></i></div></div> }

                    <div className={styles.titleWrapper}>
                        <div className={styles.title}><span>{post.title}</span></div>
                        <div className={styles.categories}>
                            <span>{category} <i className="bi bi-arrow-right"></i> {subcategory}</span>
                        </div>
                        <div className={styles.price}>
                            <span>
                                {(post.price && post.price > 0) ? <i className="bi bi-currency-dollar"></i> : ''}
                                {post.price && post.price > 0 ? post.price : lang.freePostingText}
                            </span>
                        </div>
                    </div>
                </div>

                <div className={styles.rightSide}>
                    <Button 
                        className={styles.danger}
                        disabled={isLoading} 
                        onClick={ (e) => { e.preventDefault(); e.stopPropagation(); setIsDeleteAlertVisible(true) } }
                    >
                        { isLoading ? 
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                        : 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heartbreak-fill" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8.931.586 7 3l1.5 4-2 3L8 15C22.534 5.396 13.757-2.21 8.931.586ZM7.358.77 5.5 3 7 7l-1.5 3 1.815 4.537C-6.533 4.96 2.685-2.467 7.358.77Z"/>
                            </svg>
                        }
                    </Button>
                </div>

                <DangerAlert 
                    isVisible={isDeleteAlertVisible}
                    isFooter 
                    actionButtonText={'Remove'} 
                    closeModal={ (e) => { setIsDeleteAlertVisible(false)} }
                    fireAction={ unlikeHandler }
                >
                    <div>Do you want to remove this posting from favorites?</div>
                </DangerAlert>
            </div>
            { (postDate && postDate < expiredDate) &&
                <div className={styles.expiredWrapper}>
                    <span>This posting is unavalable now, but it may be available in future!</span>
                </div>
            }
        </div>
    )
}
